/**
 * @name trash-off
 * @description Lucide SVG string.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgMTF2NiIgLz4KICA8cGF0aCBkPSJNMTQgMTd2LTMiIC8+CiAgPHBhdGggZD0iTTE2IDZWNGEyIDIgMCAwMC0yLTJoLTRhMiAyIDAgMDAtMS41NzYuNzY4IiAvPgogIDxwYXRoIGQ9Ik0xOSA2djcuMzQ0IiAvPgogIDxwYXRoIGQ9Im0yIDIgMjAgMjAiIC8+CiAgPHBhdGggZD0iTTIxIDZoLTkuMzQ0IiAvPgogIDxwYXRoIGQ9Ik0zIDZoMyIgLz4KICA8cGF0aCBkPSJNNSA2djE0YTIgMiAwIDAwMiAyaDEwYTIgMiAwIDAwMi0ydi0xIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/trash-off
 * @see https://lucide.dev/guide/packages/lucide-static - Documentation
 *
 * @returns {String}
 *
 */
const TrashOff: string = `
<svg
  class="lucide lucide-trash-off"
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
>
  <path d="M10 11v6" />
  <path d="M14 17v-3" />
  <path d="M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-1.576.768" />
  <path d="M19 6v7.344" />
  <path d="m2 2 20 20" />
  <path d="M21 6h-9.344" />
  <path d="M3 6h3" />
  <path d="M5 6v14a2 2 0 002 2h10a2 2 0 002-2v-1" />
</svg>
`;

export default TrashOff;
